import { RENTAL_LABELS_FETCHED } from '../actions/rentalLabels';

const initialState = {
  list: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RENTAL_LABELS_FETCHED:
      return {
        ...state,
        list: action.rental_labels
      };
    default:
      return state;
  }
};
